<template>
    <BaseButton
        :tooltip="localizations[lang].tooltips.tableOfContents"
        class="text-theme-icon"
        dusk="buttonAudiobookPlaylist"
        icon="baseline-view_list-24px"
        width="24px"
        height="24px"
        @click="toogleAudiobookPlaylist"
    />
</template>
<script>
import BaseButton from './BaseButton.vue';
import { mapMutations, mapState } from 'vuex';

export default {
    components: {
        BaseButton,
    },
    computed: {
        ...mapState(['localizations', 'lang']),
    },
    methods: {
        ...mapMutations(['toogleAudiobookPlaylist']),
    },
};
</script>
